const validate = (values) => {
    const errors = {};
  
    if (!values.OtherBTNotes) {
        errors.OtherBTNotes = 'Please enter other notes';
    }
    if (!values.OtherBTNotes2) {
        errors.OtherBTNotes2 = 'Please enter other notes';
    }
    if (!values.OtherBTNotes3) {
        errors.OtherBTNotes3 = 'Please enter other notes';
    }
    if (!values.OtherBTNotes4) {
        errors.OtherBTNotes4 = 'Please enter other notes';
    }
    if (!values.OtherBTNotes5) {
        errors.OtherBTNotes5 = 'Please enter other notes';
    }
    if (!Number.isInteger(values.IsTreatmentGoal)) {
        errors.IsTreatmentGoal = 'Please select option';
      }
    return errors;
  };
  export default validate;


// WEBPACK FOOTER //
// ./src/modules/scheduling/components/SessionNotes_BT_BESTABA/validate.js